import NewApiService from "@/utils/new.api.service";

export default {
    list({ commit }) {
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("cart")
            .then(({ data }) => {
                commit("set_loading",false);
                commit("set_list",data.carts);
                resolve(data.carts);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        }); 
    },
    getEmptyCart({ commit, state }) {
        commit("set_loading",true);
        if(!state.loadingEmpty){
            commit("set_loading_empty", true);
            return new Promise(resolve => {
                NewApiService.get("cart/empty")
                .then(({ data }) => {
                    commit("set_loading",false);
                    commit("set_loading_empty", false);
                    commit("set_empty_list",data.carts);
                    resolve(data.carts);
                })
                .catch(({ response }) => {
                    resolve(response.data.errors);
                });
            }); 
        }
    },
    add({commit}, model){
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.post("cart", model)
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        }); 
    }

}